import { Button, Dropdown, Row, Col } from 'react-bootstrap';
import React, { useState } from 'react';
import { FaCheckCircle, FaEllipsisV, FaMoneyBillWave } from 'react-icons/fa';

import { Checkbox } from '@mui/material';
import { IoStar } from 'react-icons/io5';
import { numberFormatter } from '../../../../../utils/helpers/numberFormater';
import { IBookCardProps } from './BookingCardItem';
import { useTranslation } from 'react-i18next';
import BookingOfferModal from './modal';
import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';
import {
    checkOfferType,
    clearHtmlFromString,
    formatDate,
    getNumberPosts,
    getSocialIcons,
} from '../../../../../shared/functions/Functions';
import { priceSplitter } from '../../../../../utils/helpers/priceSplitter';
import { BookingAcceptOfferModal } from './BookingAcceptOfferModal';
import { IOffer } from '../../../../../model/offer/IOffer';
import { DeclineOfferModal } from '../../../../influencer/offer/modal/offer-modal/components/DeclineOfferModal';
import { ConfirmSendingOfferModal } from '../../../../influencer/offer/modal/offer-modal/components/ConfirmSendingOfferModal';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { User } from '../../../../../model/user/User';
import { setSelectedUser } from '../../../../../store/brand/childOfferBrandSlice';
import ChildOfferModal from '../child-offer/modal';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';
import { ConfirmationModal } from '../../../../../shared/components/modal/ConfirmationModal';
import { CheckModalIcon, CrossModalIcon, DeleteIcon, EditIcon } from '../../../../../shared/Icons';

export function BookingListItem({
    offers,
    acceptOffer,
    declineOffer,
    approveProposal,
    declineProposal,
    deleteProposal,
    selectOffer,
    setUpdateOffers,
    setBestPickAction,
    setDeclineReason,
}: IBookCardProps) {
    const { t } = useTranslation();
    const {
        user: { isSupervisor, isClient },
    } = useSelector((state: IAllStates) => state.auth);
    const { isChildCampaign } = useSelector((state: IAllStates) => state.selectedCampaign);
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [showChildBookingModal, setShowChildBookingModal] = useState(false);
    const [offerId, setOfferId] = useState(0);
    const [userId, setUserId] = useState(0);
    const [offerModalStatus, setOfferModalStatus] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [showDeleteProposalModal, setShowDeleteProposalModal] = useState(false);
    const [isProposalDecline, setIsProposalDecline] = useState(false);
    const [offerData, setOfferData] = useState<IOffer>();
    const [approveTarget, setApproveTarget] = useState<IOffer>();
    const whoImpersonate = localStorage.getItem('whoImpersonate');
    const canSelectBestPick = whoImpersonate || isSupervisor;
    const pendingAndNegotiateStatus = ['pending', 'negotiate'];
    const dispatch = useDispatch();

    const openOfferModal = (id: number, user: number, negotiateStatus = false) => {
        setOfferId(id);
        setUserId(user);
        setShowBookingModal(true);
        if (negotiateStatus) {
            setOfferModalStatus('negotiate');
        }
    };
    const openChildOfferModal = (user: User) => {
        setUserId(userId);
        setShowChildBookingModal(true);
        dispatch(setSelectedUser(user));
    };

    const openModalAction = (isLongTerm: boolean, user: User, offerId?: number, negotiateStatus = false) => {
        isLongTerm ? openChildOfferModal(user) : openOfferModal(offerId ?? 0, user.id, negotiateStatus);
    };

    const opeDeclineModal = (id: number, offer: IOffer) => {
        setShowDeclineModal(true);
        setIsProposalDecline(false);
        setOfferId(id);
        setOfferData(offer);
    };

    const opeProposalDeclineModal = (id: number, offer: IOffer) => {
        setShowDeclineModal(true);
        setIsProposalDecline(true);
        setOfferId(id);
        setOfferData(offer);
    };

    const openConfirmModal = (id: number, offer: IOffer) => {
        setShowConfirmModal(true);
        setOfferId(id);
        setOfferData(offer);
    };

    const closeModal = () => {
        setShowBookingModal(false);
        setOfferModalStatus('');
    };

    const closeConfirmModal = () => {
        setShowConfirmModal(false);
    };

    const declineOfferAction = () => {
        if (isProposalDecline) {
            if (declineProposal) {
                declineProposal(offerId ?? 0);
            }
        } else if (declineOffer) {
            declineOffer(offerId ?? 0);
        }
        setShowDeclineModal(false);
    };

    const approveProposalAction = (id: number) => {
        if (approveProposal) {
            approveProposal(id);
        }
    };

    const openDeleteProposalModal = (id: number) => {
        setShowDeleteProposalModal(true);
        setOfferId(id);
    };

    const deleteProposalAction = () => {
        if (deleteProposal) {
            deleteProposal(offerId ?? 0);
        }
    };

    const acceptOfferConfirmModal = () => {
        acceptOffer(offerId);
    };

    return (
        <>
            <BookingOfferModal
                show={showBookingModal}
                closeModal={closeModal}
                offerId={offerId}
                modalStatus={offerModalStatus}
                userId={userId}
                acceptOffer={acceptOffer}
                declineOffer={declineOffer}
                approveProposal={approveProposal}
                declineProposal={declineProposal}
                deleteProposal={deleteProposal}
                selectOffer={selectOffer}
                setUpdateList={setUpdateOffers}
                setDeclineReason={setDeclineReason}
            />
            <ChildOfferModal
                closeModal={() => setShowChildBookingModal(false)}
                show={showChildBookingModal}
                setUpdateList={setUpdateOffers}
            />
            <BookingAcceptOfferModal
                action={acceptOfferConfirmModal}
                show={showConfirmModal}
                closeModal={closeConfirmModal}
                user={offerData?.user}
                grandTotal={priceSplitter(offerData?.price)}
                nbPosts={getNumberPosts(offerData?.totalPlatforms)}
            />
            <DeclineOfferModal
                date={formatDate(offerData?.createdAt ?? '')}
                declineOffer={declineOfferAction}
                show={showDeclineModal}
                closeModal={() => setShowDeclineModal(false)}
                setDeclineReason={setDeclineReason}
            />
            <ConfirmSendingOfferModal
                action={() => approveProposalAction(approveTarget?.id ?? 0)}
                grandTotal={priceSplitter(approveTarget?.price)}
                show={!!approveTarget}
                disableButton={false}
                closeModal={() => setApproveTarget(undefined)}
                nbPosts={getNumberPosts(approveTarget?.totalPlatforms)}
                user={approveTarget?.user}
                isProposalApproval={true}
            />
            <ConfirmationModal
                show={showDeleteProposalModal}
                closeModal={() => setShowDeleteProposalModal(false)}
                action={deleteProposalAction}
                title={t('brand.campaign.book.offer.delete_proposal')}
                description={t('brand.campaign.book.offer.delete_proposal_confirm')}
            />

            {offers?.map(offer => (
                <Row
                    key={`${offer?.id}-list-item`}
                    className={`booking-list-card border-${offer.status} ${
                        offer?.isProposed ? 'border-proposed' : ''
                    } align-items-center position-relative`}
                >
                    {offer?.isProposed && offer?.isConvertedToOffer && (
                        <div>
                            <span className="position-absolute d-flex" style={{ top: 10, right: 10, zIndex: 2 }}>
                                <TooltipOverlay content={t('brand.campaign.book.offer.offer_sent_tooltip')}>
                                    <img src="/icons/approved-icon.svg" alt="Offer sent" />
                                </TooltipOverlay>
                            </span>
                        </div>
                    )}
                    <Col
                        className="col-md-auto col-12 max-h-180px position-relative cursor-pointer px-0 overflow-hidden"
                        onClick={() => openModalAction(offer?.isLongTerm, offer.user, offer?.id)}
                    >
                        {(offer?.isLongTerm || offer?.isAddonsOnly || offer?.isOnTop) && (
                            <div className="diagonal-text">
                                <span className="diagonal-text-sm">
                                    {t(
                                        `brand.campaign.briefing.overview_card.${checkOfferType(
                                            offer?.isLongTerm,
                                            offer?.isOnTop,
                                            offer?.isAddonsOnly,
                                            true
                                        )}`
                                    )}
                                </span>
                            </div>
                        )}
                        <CustomImageHandler
                            altTag={offer?.user?.profilePhoto?.name ?? ''}
                            classes="booking-list-image "
                            photoPath={offer?.user?.profilePhoto?.thumbnail ?? ''}
                            thumbnailPath={offer?.user?.profilePhoto?.thumbnail}
                        />
                    </Col>

                    <div
                        className="py-3 row px-md-3 flex-wrap align-items-center justify-content-between col"
                        style={{ gap: 18 }}
                    >
                        <div className="col" onClick={() => openModalAction(offer?.isLongTerm, offer.user, offer?.id)}>
                            <h5>{offer?.user?.displayName}</h5>
                            <span className="text-muted">{offer?.user?.displayName}</span>
                            <div className={`rating mt-1 ${offer?.user?.totalRating === 0 && 'd-none'}`}>
                                {offer?.user?.totalRating?.toFixed(2) ?? 0}
                                <IoStar className="text-primary" />
                            </div>
                        </div>
                        <div
                            style={{ gap: 12 }}
                            className="d-flex align-items-center cursor-pointer col"
                            onClick={() => setOfferId(offer.id)}
                        >
                            {offer.isAddonsOnly ? (
                                <h6>{t(`brand.campaign.briefing.overview_card.addons_only`)}</h6>
                            ) : (
                                <>
                                    {offer?.totalPlatforms?.map(platform => (
                                        <React.Fragment key={platform.id}>
                                            {getSocialIcons({
                                                iconPath: platform.path,
                                                dataTop: `x${platform.nbPostsTotal}`,
                                                dataDown: numberFormatter(platform.followers),
                                                colorText: 'primary',
                                                parentClasses: 'w-100',
                                            })}
                                        </React.Fragment>
                                    ))}
                                </>
                            )}
                        </div>
                        <div className="col" onClick={() => openModalAction(offer?.isLongTerm, offer.user, offer?.id)}>
                            <div className="d-flex align-items-center cursor-pointer ">
                                {offer?.isLongTerm ? (
                                    <p className="text-primary mb-0">{t('brand.campaign.book.offer.part_long_term')}</p>
                                ) : (
                                    <h4 className="euro-symbol mb-0 text-nowrap">
                                        {priceSplitter(Math.round(offer?.price))}
                                    </h4>
                                )}
                                {(offer?.isRequested || offer?.isProposed) && (
                                    <p
                                        className={`mx-2 status ${
                                            offer?.isProposed
                                                ? offer?.isApproved
                                                    ? 'proposal-approved'
                                                    : offer?.isDeclined
                                                    ? 'proposal-declined'
                                                    : 'primary'
                                                : 'invite'
                                        } text-dark`}
                                    >
                                        {offer?.isProposed
                                            ? offer?.isApproved
                                                ? t('brand.campaign.book.offer.approved')
                                                : offer?.isDeclined
                                                ? t('brand.campaign.book.offer.declined')
                                                : t('general.campaign_status.proposed')
                                            : t('general.campaign_status.invite')}
                                    </p>
                                )}
                            </div>
                            {!!offer?.additionalPrice && (
                                <span className="text-muted font-10">
                                    <FaMoneyBillWave className="text-primary mr-1 font-14" />
                                    {t('brand.campaign.book.offer.additional_costs_included')}
                                </span>
                            )}
                        </div>
                        <div className="justify-content-end d-flex col">
                            {offer?.description && (
                                <div className="d-flex align-items-center">
                                    <p
                                        className="list-intro cursor-pointer px-1"
                                        onClick={() => openModalAction(offer?.isLongTerm, offer.user, offer?.id)}
                                    >
                                        {clearHtmlFromString(offer?.description || '-')}
                                    </p>
                                </div>
                            )}
                            <div className="d-flex flex-column align-items-end ">
                                <Checkbox
                                    className={`${
                                        (isClient ||
                                            offer?.buttonType === 'Open' ||
                                            offer.buttonType === 'Resume' ||
                                            isChildCampaign) &&
                                        'd-none'
                                    } px-0 mb-lg-2`}
                                    checked={offer?.isSelected}
                                    onClick={() => selectOffer(offer?.id, !offer.isSelected)}
                                />
                                <div className="d-flex align-items-center mt-lg-2">
                                    {!isClient && offer?.canCounter && (
                                        <Dropdown className="mx-2">
                                            <Dropdown.Toggle className="" variant="light" id="dropdown-basic">
                                                <FaEllipsisV className="text-secondary" />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() =>
                                                        openModalAction(offer?.isLongTerm, offer.user, offer?.id)
                                                    }
                                                    className="d-flex align-items-center"
                                                >
                                                    <i className="fi fi-rr-messages-question icon-fixed me-2"></i>
                                                    {t('brand.campaign.book.offer.negotiate')}
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => opeDeclineModal(offer?.id, offer)}
                                                    className="d-flex align-items-center danger-hover"
                                                >
                                                    <CrossModalIcon width={16} height={16} className="me-2" />
                                                    {t('brand.campaign.book.offer.deny_offer')}
                                                </Dropdown.Item>
                                                {/* {canSelectBestPick &&
                                                    pendingAndNegotiateStatus.includes(offer?.status) && (
                                                        <Dropdown.Item onClick={() => setBestPickAction(offer?.id)}>
                                                            {offer.isBestPick
                                                                ? t(
                                                                      'brand.campaign.book.offer.filters.remove_best_pick'
                                                                  )
                                                                : t('brand.campaign.book.offer.filters.set_best_pick')}
                                                        </Dropdown.Item>
                                                    )} */}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                    {isClient && offer?.isProposed && !offer?.isApproved && !offer?.isDeclined && (
                                        <Dropdown className="mx-2">
                                            <Dropdown.Toggle className="" variant="light" id="dropdown-basic">
                                                <FaEllipsisV className="text-secondary" />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => setApproveTarget(offer)}>
                                                    <div className="d-flex align-items-center">
                                                        <CheckModalIcon width={14} height={14} className="me-2" />
                                                        {t('brand.campaign.book.offer.approve_proposal')}
                                                    </div>
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => opeProposalDeclineModal(offer?.id, offer)}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <CrossModalIcon
                                                            width={14}
                                                            height={14}
                                                            viewBox="4 4 16 16"
                                                            className="me-2"
                                                        />
                                                        {t('brand.campaign.book.offer.decline_proposal')}
                                                    </div>
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                    {!isClient && offer?.isProposed && !offer?.isApproved && (
                                        <Dropdown className="mx-2">
                                            <Dropdown.Toggle className="" variant="light" id="dropdown-basic">
                                                <FaEllipsisV className="text-secondary" />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() =>
                                                        openModalAction(offer?.isLongTerm, offer.user, offer?.id, true)
                                                    }
                                                >
                                                    <EditIcon width={20} height={20} className="dropdown-menu-icon" />
                                                    {t('brand.campaign.book.offer.edit_proposal')}
                                                </Dropdown.Item>
                                                {!offer?.isDeclined && (
                                                    <Dropdown.Item
                                                        className="text-danger"
                                                        onClick={() => openDeleteProposalModal(offer?.id)}
                                                    >
                                                        <DeleteIcon
                                                            width={20}
                                                            height={20}
                                                            className="dropdown-menu-icon"
                                                        />
                                                        {t('brand.campaign.book.offer.delete_proposal')}
                                                    </Dropdown.Item>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                    <Button
                                        className="position-relative"
                                        size="sm"
                                        onClick={
                                            isClient || offer?.buttonType === 'Open' || offer.buttonType === 'Resume'
                                                ? () =>
                                                      openModalAction(
                                                          offer?.isLongTerm,
                                                          offer.user,
                                                          offer?.id,
                                                          offer.buttonType === 'Resume'
                                                      )
                                                : () => openConfirmModal(offer?.id, offer)
                                        }
                                    >
                                        {t(`general.button.${isClient ? 'Open' : offer?.buttonType}`)}
                                        {offer?.hasUnreadComments && (
                                            <div
                                                id="bullet"
                                                className="red-dot position-absolute"
                                                style={{ top: '-5px', right: '-5px' }}
                                            />
                                        )}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Row>
            ))}
        </>
    );
}
